var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#E6F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 20.75H19.5C20.8807 20.75 22 19.6307 22 18.25C22 17.5596 22.5596 17 23.25 17H30.75C31.4404 17 32 17.5596 32 18.25C32 19.6307 33.1193 20.75 34.5 20.75H35.75C37.1307 20.75 38.25 21.8693 38.25 23.25V34.5C38.25 35.8807 37.1307 37 35.75 37H18.25C16.8693 37 15.75 35.8807 15.75 34.5V23.25C15.75 21.8693 16.8693 20.75 18.25 20.75",
    stroke: "#7EB3BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 28.25,
    r: 3.75,
    stroke: "#7EB3BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectorLogo);
export default __webpack_public_path__ + "static/media/inspector-logo.5caa92085f26becc345afd73dbfb7b0c.svg";
export { ForwardRef as ReactComponent };